module.exports = {
      id: "protichinta-logo-usage",
      viewBox: "0 0 190 57.9",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#protichinta-logo",
      toString: function () {
        return this.url;
      }
    }